module.exports = "pegasus_template/assets/themecapture1/tickets/101.png";